export const capitalizeFirstLetter = (str: string | undefined) => str ? str[0].toUpperCase() + str.slice(1).toLowerCase() : '';